// En SidebarHeader.tsx
import React from 'react';
// Asegúrate que la ruta a lucide-react sea correcta si usas ese icono
import { Shield } from 'lucide-react';

// Define las propiedades que el componente espera recibir
interface SidebarHeaderProps {
  isAdmin: boolean; // Para saber si mostrar el panel de admin
  businessName?: string | null; // El nombre del negocio (puede ser nulo o no existir)
  logoUrl?: string | null; // La URL del logo (puede ser nula o no existir)
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({ isAdmin, businessName, logoUrl }) => {
  return (
    <> {/* Fragmento para agrupar los elementos sin añadir un div extra al DOM */}

      {/* SECCIÓN PARA USUARIOS QUE NO SON ADMIN */}
      {!isAdmin && (
        // Contenedor principal para esta sección, centrado y con estilos
        // --- CAMBIO: Reducido el margen inferior --- vvvvv
        <div className="px-4 py-3 mb-2 rounded-md bg-surface flex flex-col items-center text-center">
        {/* Se cambió mb-4 por mb-2 */}

          {/* 1. Muestra la imagen del LOGO si existe la 'logoUrl' */}
          {logoUrl && (
            <img
              src={logoUrl} // Fuente de la imagen
              alt={businessName ? `${businessName} Logo` : 'Logo del Negocio'} // Texto alternativo
              // Clases para estilo y tamaño del logo (ajústalas si necesitas)
              className="h-12 w-auto max-w-[90%] mb-2 object-contain"
            />
          )}

          {/* 2. Muestra el NOMBRE DEL NEGOCIO si existe 'businessName' */}
          {businessName && (
            <p className="mt-1 text-sm font-semibold truncate text-content w-full">
              {businessName}
            </p>
          )}

           {/* 3. Mensaje alternativo si NO hay ni logo ni nombre */}
           {!logoUrl && !businessName && (
             <p className="text-sm text-content-3">(Información del negocio)</p>
           )}

        </div>
      )}

      {/* SECCIÓN PARA USUARIOS ADMIN */}
      {isAdmin && (
        // Contenedor y estilos para el panel de administración
        // --- CAMBIO: Reducido el margen inferior --- vvvvv
        <div className="px-4 py-3 mb-2 rounded-md bg-surface-2 border border-line">
        {/* Se cambió mb-4 por mb-2 */}
          <h3 className="text-sm font-medium text-content-2 flex items-center">
            <Shield className="h-4 w-4 mr-1 text-content-3" />
            Panel de Administración
          </h3>
        </div>
      )}
    </>
  );
};

export default SidebarHeader;